// client/src/components/world/CosmicBackdrop.jsx
// Итерация 8.3b: космический фон (fallback для «космос» / «перелёт»).
// Звёзды + ночное окружение. Позже (Итерация 9+) — динамический скайбокс из бэкенда.
//
// ⚠️ Тонкий компонент. Не знает про locationInfo/characterMeta — только props.

import React from 'react';
import { Stars } from '@react-three/drei';

export default function CosmicBackdrop() {
  return (
    <group name="cosmic-backdrop">
      {/* Звёздное поле — drei <Stars> */}
      <Stars
        radius={100}
        depth={50}
        count={5000}
        factor={4}
        saturation={0}
        fade
        speed={1}
      />
    </group>
  );
}
